module.exports = __webpack_public_path__ + "assets/img/app-title.d2c13696.png";